import { render } from "./GhostApp.vue?vue&type=template&id=6fee25aa&lang=pug"
import script from "./GhostApp.vue?vue&type=script&lang=js"
export * from "./GhostApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__